import React from "react";

import "react-datepicker/dist/react-datepicker.css";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import ReactDOM from "react-dom";
// import swDev from './swDev'
import App from "./App";
import "./index.css";
import "./styles/themeTokens.css";
import "./styles/darkTheme.css";
import "./Libraries/UBButton/styles.module.css";
import "../src/assets/css/NewStyle.css";
import { initGoogleTagManager } from "./utils/googleTagManager";

const googleSiteVerification = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION;
if (googleSiteVerification) {
  let meta = document.querySelector('meta[name="google-site-verification"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "google-site-verification";
    document.head.appendChild(meta);
  }
  meta.content = googleSiteVerification;
}

initGoogleTagManager();

ReactDOM.render(<App />, document.getElementById("root"));

reportWebVitals();
// swDev();
